import React from 'react';
import styles from './DownloadApp.module.css';
import { ReactComponent as QRCode } from '../../assets/images/download-qr-code.svg';
import sharedButtonStyles from '../button/Button.module.css';
import { ANDROID_DOWNLOAD_LINK, IOS_DOWNLOAD_LINK } from '../../constants/constants';

const appStore = require('../../assets/icons/apple.svg').default;
const googlePlay = require('../../assets/icons/google_play.svg').default;

export default function DownloadApp() {
  return (
    <div className={styles.content}>
      <p>
        You are all set!
        <br />
        <br />
        To view your data and receive insights,
        {' '}
        <span>download</span>
        {' '}
        the free Flutter Care mobile app via the QR code or icons below.
      </p>
      <div className={styles.qrcode}>
        <QRCode width="100%" height="100%" />
      </div>
      <div className={styles.download}>
        <a href={IOS_DOWNLOAD_LINK} className={sharedButtonStyles.FCButton}>
          <img src={appStore} alt="Download from Apple App Store" />
          iOS
        </a>
        <a href={ANDROID_DOWNLOAD_LINK} className={sharedButtonStyles.FCButton}>
          <img src={googlePlay} alt="Download from Google Play Store" />
          Android
        </a>
      </div>
    </div>
  );
}
